// src/features/editor/lib/blockSignature.ts
import type { Block } from '@/types/blocks'

/**
 * Вложенные `id` (варианты квиза, пары, легаси-`questions`) — не правка автора:
 * бэк их не читает и на КАЖДЫЙ `PUT` квиза заводит варианты заново с новыми id.
 * Если сравнивать с ними, черновик, отставший от ответа хоть на одно
 * сохранение, навсегда «грязный» — и автосохранение крутится по кругу
 * (пойман живьём: 9372 → 9376 → 9378 … каждые две секунды). То же с
 * вложенными `createdAt`/`updatedAt`: пары «Соответствия» пересоздаются с новым
 * временем на каждый PUT (пойман живьём на блоке match). Свой `id` блока
 * остаётся — это тождество, а не содержимое.
 */
const SERVER_ONLY = new Set(['id', 'questionId', 'createdAt', 'updatedAt'])
const withoutNestedIds = (key: string, value: unknown): unknown =>
  SERVER_ONLY.has(key) ? undefined : value

const signatureOf = (b: { id?: number }): string => {
  const { id, ...rest } = b
  return `${id ?? ''}|${JSON.stringify(rest, withoutNestedIds)}`
}

/** Сравнение двух блоков без серверных отметок времени и вложенных id. */
export const blockSignature = (b: Block): string => {
  const { createdAt: _c, updatedAt: _u, ...rest } = b
  return signatureOf(rest)
}

/**
 * То же, но и без `order`: позицией владеет реордер, а не черновик, и её смена —
 * не «блок переписали под автором» (I-2) и не правка автора, которую стоит
 * запоминать в истории (п.11).
 */
export const contentSignature = (b: Block): string => {
  const { createdAt: _c, updatedAt: _u, order: _o, ...rest } = b
  return signatureOf(rest)
}
